import React from 'react'

function AIChat() {
  return (
    <div>AIChat</div>
  )
}

export default AIChat